import { render, staticRenderFns } from "./GetSonyPaymentToken.vue?vue&type=template&id=10380bbb&"
import script from "./GetSonyPaymentToken.vue?vue&type=script&lang=ts&"
export * from "./GetSonyPaymentToken.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports